import { Backdrop } from '@mui/material';
import React, { useContext } from 'react';

import { FullScreenToggleButton } from './FullscreenToggle';
import { Scene } from './Scene';
import { SceneCanvasContext, DisplayMode } from './SceneCanvasContext';

export const SceneDisplay: React.FC = () => {
  const { displayMode } = useContext(SceneCanvasContext);

  return (
    <>
      {displayMode === DisplayMode.NORMAL && (
        <>
          <FullScreenToggleButton />
          <Scene />
        </>
      )}
      {displayMode === DisplayMode.FULLSCREEN && (
        <Backdrop sx={{ padding: '2rem' }} open={true}>
          <FullScreenToggleButton />

          <div style={{ width: '100%', height: '100%', textAlign: 'center' }}>
            <Scene />
          </div>
        </Backdrop>
      )}
    </>
  );
};
